import { render, staticRenderFns } from "./WidgetViewer.vue?vue&type=template&id=1ff260d2&scoped=true"
import script from "./WidgetViewer.vue?vue&type=script&lang=js"
export * from "./WidgetViewer.vue?vue&type=script&lang=js"
import style0 from "./WidgetViewer.vue?vue&type=style&index=0&id=1ff260d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff260d2",
  null
  
)

export default component.exports